import { render, staticRenderFns } from "./LocatorMenu.vue?vue&type=template&id=bbc6c7d2&scoped=true&"
import script from "./LocatorMenu.vue?vue&type=script&lang=ts&"
export * from "./LocatorMenu.vue?vue&type=script&lang=ts&"
import style0 from "./LocatorMenu.vue?vue&type=style&index=0&id=bbc6c7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc6c7d2",
  null
  
)

export default component.exports